<template>
    <!-- duration is set to 90 minutes (5400 seconds) -->
    <!-- loop is set to true to keep the timer running -->
    <div>
      <Vidle @idle="showModal" :loop="false" :duration="sessionExpirationTime" v-if="sessionExpirationTime" />
      <div class="v-idle-modal" v-if="showVidleModal">
        <div class="v-idle-modal-body">
          <p class="body-heading">Your session has expired due to inactivity</p>
          <p class="body-sub-heading">Please login to continue</p>
          <div class="v-idle-modal-footer">
            <button class="modal-ok-btn" @click="onIdle">OK</button>
          </div>
        </div>
      </div>
    </div>
  </template>
  <script>
  import Vidle from "v-idle";
  import Helper from "@/resource/Helper"
  export default {
    name: "SessionTimer",
    data() {
      return {
        sessionExpirationTime: null,
        showVidleModal: false,
      };
    },
    computed: {
      isAuthenticated() {
        return this.$store.getters.authenticated
      }
    },
    components: { Vidle },
    methods: {
      showModal() {
        this.showVidleModal = true;
        Helper.clearToken();
      },
      onIdle() {
        // this.$router.replace("/logout");
        Helper.logout();
        this.showVidleModal = false;
        this.$store.commit("setAuthentication", false);
        this.sessionExpirationTime = null;
      },
    },
    watch: {
      isAuthenticated(newValue) {
        this.sessionExpirationTime = newValue ? parseInt(this.$endpoint.SET_SESSION_EXPIRE_TIME_OUT) : null;
  
      },
    },
    mounted() {
      this.isAuthenticated ? this.sessionExpirationTime = parseInt(this.$endpoint.SET_SESSION_EXPIRE_TIME_OUT) : this.sessionExpirationTime = null
    },
  };
  </script>
  <style scoped>
  .v-idle {
    display: none;
  }
  
  .v-idle-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.75);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 9999;
  }
  
  .v-idle-modal-body {
    background-color: #fff;
    padding: 1.5rem;
    border-radius: 0.5rem;
    box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.1);
  }
  
  .v-idle-modal-footer {
    background-color: #fff;
    display: flex;
    justify-content: flex-end;
  }
  
  .body-heading {
    font-size: 1.15rem;
    font-weight: 600;
    margin-bottom: 0.25rem;
  }
  
  .body-sub-heading {
    font-size: 1rem;
    margin-bottom: 0;
  }
  
  .modal-ok-btn {
    background: #1890ff;
    padding: .5rem 1.25rem;
    border: none;
    border-radius: .25rem;
    color: white;
    font-weight: 600;
  }
  </style>